import { useAuth } from '@/stores/auth.store';
import { SocketMessage, EndDeviceMessage } from '@ncss/models';

import { io, Socket } from 'socket.io-client';

export function useLiveDevices() {
  const { token } = useAuth();
  let socket: Socket | undefined;
  let onMessageCb: undefined | ((msg: SocketMessage) => void);
  let onEndDeviceMessageCb: undefined | ((msg: EndDeviceMessage) => void);

  function start(gatewayId: number) {
    try {
      stop();
      socket = io(import.meta.env.VITE_API_HOST, {
        auth: { token },
        query: { gatewayId },
        transports: ['websocket'],
      });

      socket.on('message', (data) => {
        const msg = SocketMessage.create(data);
        if (msg) {
          if (onMessageCb) {
            onMessageCb(msg);
          }
          if (onEndDeviceMessageCb && msg instanceof EndDeviceMessage) {
            onEndDeviceMessageCb(msg);
          }
        }
      });
    } catch (e) {
      console.log('ERROR STARTING LIVE DEVICES', e);
    }
  }

  function sendMessage(msg: SocketMessage) {
    try {
      socket?.emit('message', msg);
    } catch (e) {
      console.log('ERROR EMITTING MESSAGE', e);
    }
  }

  function stop() {
    onMessageCb = undefined;
    try {
      socket?.close();
      socket = undefined;
    } catch (e) {
      console.log('ERROR CLOSING SOCKET', e);
    }
  }

  function onMessage(cb: (msg: SocketMessage) => void) {
    onMessageCb = cb;
  }

  function onEndDeviceMessage(cb: (msg: EndDeviceMessage) => void) {
    onEndDeviceMessageCb = cb;
  }

  return {
    start,
    stop,
    sendMessage,
    onMessage,
    onEndDeviceMessage,
  };
}
